// Generated by ReScript, PLEASE EDIT WITH CARE


function getIconsVm(data) {
  return {
          pickup: data.pickup.icon,
          drop: data.drop.icon,
          phone: data.phone.icon,
          name: data.name.icon,
          requirement: data.requirement.icon
        };
}

function getErrorsMsgsVm(data) {
  return {
          pickup: data.pickup.error_msg,
          drop: data.drop.error_msg,
          phone: data.phone.error_msg,
          name: data.name.error_msg,
          requirement: data.requirement.error_msg
        };
}

function getPlaceHoldersVm(data) {
  return {
          pickup: data.pickup.place_holder,
          drop: data.drop.place_holder,
          phone: data.phone.place_holder,
          name: data.name.place_holder,
          requirement: data.requirement.place_holder
        };
}

function getLabelsVm(data) {
  return {
          pickup: data.pickup.label,
          drop: data.drop.label,
          phone: data.phone.label,
          name: data.name.label,
          requirement: data.requirement.label
        };
}

function getIconLabelVm(icon, label) {
  return {
          icon: icon,
          label: label
        };
}

function getRequiremnetLabels(personal, business) {
  return {
          personal: personal,
          business: business
        };
}

function getRequirementOption(data, requirement) {
  return {
          title: data.title,
          value_label: data.value_label,
          requirement: requirement,
          desc: data.desc,
          icon: data.icon
        };
}

function getRequiremnetOptions(data) {
  return {
          personal: getRequirementOption(data.personal_option, /* Personal */0),
          business: getRequirementOption(data.business_option, /* Business */1),
          requirement_title: data.requirement_title
        };
}

function getModalContent(title, icon) {
  return {
          title: title,
          icon: icon
        };
}

function getLeadFlowVm(data) {
  return {
          labels: getLabelsVm(data.field_params),
          place_holders: getPlaceHoldersVm(data.field_params),
          errors_msgs: getErrorsMsgsVm(data.field_params),
          icons: getIconsVm(data.field_params),
          submit_icon_label: {
            icon: data.get_estimate_icon,
            label: data.get_estimate_label
          },
          requirement_labels: {
            personal: data.personal_use_label,
            business: data.business_use_label
          },
          consent_label: data.consent_label,
          mobile_modal_content: {
            title: data.modal_title,
            icon: data.modal_close_icon
          },
          vehcile_modal_content: {
            title: data.vehcile_modal_title,
            icon: data.modal_close_icon
          },
          city_title_desc: data.city_title_desc,
          location_icon: data.location_icon,
          drop_down_icon: data.drop_down_icon
        };
}

function getSpotLeadFlowVm(data) {
  return {
          labels: getLabelsVm(data.field_params),
          place_holders: getPlaceHoldersVm(data.field_params),
          errors_msgs: getErrorsMsgsVm(data.field_params),
          icons: getIconsVm(data.field_params),
          submit_icon_label: {
            icon: data.get_estimate_icon,
            label: data.get_estimate_label
          },
          requirement_options: getRequiremnetOptions(data),
          consent_label: data.consent_label,
          city_title_desc: data.city_title_desc,
          mobile_modal_content: {
            title: data.modal_title,
            icon: data.modal_close_icon
          }
        };
}

function getVm(data) {
  return {
          fare_estimate_content: getLeadFlowVm(data.fare_estimate_content),
          spot_fare_estimate_content: getSpotLeadFlowVm(data.spot_fare_estimate_content)
        };
}

export {
  getIconsVm ,
  getErrorsMsgsVm ,
  getPlaceHoldersVm ,
  getLabelsVm ,
  getIconLabelVm ,
  getRequiremnetLabels ,
  getRequirementOption ,
  getRequiremnetOptions ,
  getModalContent ,
  getLeadFlowVm ,
  getSpotLeadFlowVm ,
  getVm ,
}
/* No side effect */
